import React, {useState} from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";

const Filters = ({ setFilters, filters }) => {
    const { sosManagementActionsUsers } = useReportFiltersFetch({ fetchSosManagementActionsUsers: true });

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                        <InputDateTime
                            id="dtStart"
                            label="Data/hora inicial *"
                            selected={filters.dtStart ? new Date(filters.dtStart) : null}
                            onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />

                        <InputDateTime
                            id="dtEnd"
                            label="Data/hora final *"
                            selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                            onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />

                        <SelectComponent
                            id="users"
                            label='Assumido por'
                            isMulti={true}
                            wrapValues={true}
                            options={sosManagementActionsUsers}
                            value={filters.users}
                            onChange={(value) => setFilters(prev => ({ ...prev, users: value }))}
                            classNameWrapper={"w-full"}
                        />

                </form>
            </div>
        </>
    );
};

export default Filters;